import { Avatar, Button } from '@pickleballinc/react-ui';

import ImageWithFallback from '@/components/atoms/ImageWithFallback';
import { TeamLeagueTeamsInfo } from '@/entities/TeamLeagueTeamsInfo';
import { TeamPlayerInfo } from '@/lib/types';
import { determinePlayerPhotoForPlayerMovesUrl } from '@/lib/helper';
import { TeamInfo } from '@/entities/TeamLeagueTeamInfo';

interface TradePreviewProps {
	currentTeamDropped: TeamPlayerInfo[];
	otherTeamDropped: TeamPlayerInfo[];
	currentTeam: TeamInfo;
	selectedTeam?: TeamLeagueTeamsInfo;
	goToPreview: () => void;
}
export function TradePreview({ currentTeamDropped, otherTeamDropped, currentTeam, selectedTeam, goToPreview }: TradePreviewProps) {
	return (
		<div className="hidden flex-col gap-3 md:flex lg:mr-32">
			<div className=" flex flex-col gap-4">
				<p className="text-2xl font-semibold text-darkorange-600">Trade preview</p>
				<div className="flex items-center gap-2">
					<ImageWithFallback
						src={currentTeam?.logo?.url || '/assets/images/placeholder.png'}
						alt={currentTeam.title}
						fallbackSrc="/assets/images/placeholder.png"
						className={`rounded object-cover`}
						width={40}
						height={20}
					/>
					<p className="text-lg font-semibold text-gray-900">{currentTeam.title}</p>
				</div>
				{currentTeamDropped.map((player) => (
					<div key={player.uuid} className="flex items-center gap-4 pl-8 text-lg font-semibold text-gray-900">
						<Avatar size="xs" imageUrl={determinePlayerPhotoForPlayerMovesUrl(player.photo)} />
						<p>
							{player.firstName} {player.lastName}
						</p>
					</div>
				))}
			</div>
			<p className="font-medium text-darkorange-600">to</p>
			{selectedTeam && (
				<div className="flex flex-col gap-4">
					<div className="flex items-center gap-2">
						<ImageWithFallback
							src={selectedTeam.logo ? selectedTeam.logo.url : '/assets/images/placeholder.png'}
							alt={selectedTeam.title}
							fallbackSrc="/assets/images/placeholder.png"
							className={`rounded object-cover`}
							width={40}
							height={20}
						/>
						<p className="text-lg font-semibold text-gray-900">{selectedTeam.title}</p>
					</div>
					<p className="font-medium text-darkorange-600">for</p>
					{otherTeamDropped.map((player) => (
						<div key={player.uuid} className="flex items-center gap-4 pl-8 text-lg font-semibold text-gray-900">
							<Avatar size="xs" imageUrl={determinePlayerPhotoForPlayerMovesUrl(player.photo)} />
							<p>
								{player.firstName} {player.lastName}
							</p>
						</div>
					))}
				</div>
			)}
			{otherTeamDropped.length > 0 ? (
				<Button
					onClick={goToPreview}
					variant="secondary-color"
					className="!text-darkorange-600 !bg-darkorange-50 !border-darkorange-700 !outline-none !border-none"
				>
					Review trade request
				</Button>
			) : (
				<p className="font-semibold text-darkorange-600">Next step: Pick {!selectedTeam ? 'team' : 'player'}</p>
			)}
		</div>
	);
}
